import { UsergroupAddOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

import { queryMemberGroupApi } from '@eastcoal/api/auth/group/queryMemberGroup'

import { pick } from '@eastcoal/common/utils/object'

import { formatterDetail } from '../CustomGroupForm/utils'
import { useCustomMemberGroupStore } from '../Store/hooks'

export const CreateOrUpdateCustomGroupButton = () => {
  const { toggleFormVisible, value, currentGroup, setCurrentGroup, disabled } =
    useCustomMemberGroupStore(state =>
      pick(state, [
        'toggleFormVisible',
        'setCurrentGroup',
        'value',
        'disabled',
        'currentGroup'
      ])
    )
  const temporaryGroup = currentGroup || value?.find(group => group.temporary)
  const onClick = async () => {
    if (temporaryGroup && !temporaryGroup?.members?.length) {
      await queryMemberGroupApi({
        id: temporaryGroup?.id
      }).then(detail => {
        setCurrentGroup(formatterDetail(detail))
      })
    } else {
      if (temporaryGroup) setCurrentGroup(temporaryGroup)
    }

    toggleFormVisible()
  }

  return disabled ? null : (
    <Tooltip title='创建或者编辑自定义分组会员'>
      <Button icon={<UsergroupAddOutlined />} type='link' onClick={onClick} />
    </Tooltip>
  )
}
